import { useEffect, useState } from "react";
import { Radio, Save } from "lucide-react";
import { toast } from "sonner";
import client from "@/lib/api";

export default function LiveAdminPanel() {
  const [url, setUrl] = useState("");
  const [label, setLabel] = useState("");
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    client.get("/admin/settings/live").then((r) => {
      setUrl(r.data.url || ""); setLabel(r.data.label || ""); setEnabled(!!r.data.enabled);
    }).catch((e) => console.error("Load live settings failed:", e));
  }, []);

  const save = async () => {
    try {
      const { data } = await client.put("/admin/settings/live", { url, label, enabled });
      if (data?.notified > 0) toast.success(`Diretta attivata! Inviati ${data.notified} avvisi push agli utenti iscritti.`);
      else toast.success("Impostazioni diretta salvate.");
    } catch (e) { toast.error("Errore nel salvataggio."); }
  };

  return (
    <div className="rounded-sm border-2 border-legend-red bg-white dark:bg-legend-paper p-5 mb-6" data-testid="live-admin-panel">
      <div className="flex items-center gap-2 mb-1"><Radio size={18} className="text-legend-red" /><h3 className="font-display font-bold uppercase">Diretta / Live Timing</h3></div>
      <p className="text-xs text-slate-500 mb-4">Incolla il link della diretta o del live timing della gara del giorno. Attivando l'interruttore, in tutto il sito comparirà il pulsante rosso "🔴 Segui la diretta" e verrà inviato un <strong>avviso push</strong> a chi ha attivato le notifiche.</p>

      <label className="block text-xs font-mono uppercase tracking-wide text-slate-500 mb-1">Link diretta / live timing</label>
      <input
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        data-testid="live-url-input"
        placeholder="https://youtube.com/live/... oppure link cronometraggio"
        className="w-full rounded-sm border border-slate-300 dark:border-slate-700 bg-transparent px-3 py-2 text-sm mb-3"
      />
      <label className="block text-xs font-mono uppercase tracking-wide text-slate-500 mb-1">Etichetta pulsante (opzionale)</label>
      <input
        value={label}
        onChange={(e) => setLabel(e.target.value)}
        data-testid="live-label-input"
        placeholder="🔴 GARA IN CORSO: CLICCA QUI"
        className="w-full rounded-sm border border-slate-300 dark:border-slate-700 bg-transparent px-3 py-2 text-sm mb-4"
      />

      <div className="flex items-center justify-between">
        <label className="flex items-center gap-2 cursor-pointer select-none">
          <input type="checkbox" checked={enabled} onChange={(e) => setEnabled(e.target.checked)} data-testid="live-enabled-toggle" className="w-5 h-5 accent-legend-red" />
          <span className="text-sm font-semibold">{enabled ? "Diretta ATTIVA (pulsante visibile)" : "Diretta disattivata"}</span>
        </label>
        <button onClick={save} data-testid="live-save-btn" className="inline-flex items-center gap-2 bg-legend-red hover:bg-legend-dark text-white font-bold uppercase tracking-wide text-sm px-5 py-2.5 rounded-sm transition-colors">
          <Save size={15} /> Salva
        </button>
      </div>
    </div>
  );
}
